import {useQuery} from '@tanstack/react-query';
import { authorizedGet } from '../functions/AuthService';

export const useDashboard = () => {
    return useQuery({
        queryKey: ['dashboard', 'orders'],
        queryFn: async () => {
            const response = await authorizedGet("/ordenes/getOrdenes");
            return await response.body.json();
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 15, //Keep it in memory for 15 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}